import { useContext } from "react";

import helpers from "../../utils/helpers";
import {
  CAUSED_BY_BACK,
  CAUSED_BY_CORS,
  CAUSED_BY_FRONT,
  CAUSED_BY_TIMEOUT,
  TIME_LIMIT,
  ERROR_CORS,
  URL_AUDITORY,
} from "../utils/constants";
import {
  getError,
  getLineError,
  getUrlClient,
  getUrlConsume,
  isEmpty,
} from "../utils/functions";
import { logsAuditory, setErrorLog, setSuccessLog } from "./actions";
import { AuditoryContext, outAuditory as store } from "./feature";

export const outAuditory = store;
export const useAuditory = () => useContext(AuditoryContext);

const readError = (error, dateIni, dateEnd) => {
  const seconds = Math.ceil((dateEnd.getTime() - dateIni.getTime()) / 1000);
  const request = Object.values(error || {});
  const message = request.find(
    (err) => !isEmpty(err) && Boolean(err?.response)
  );
  if (message?.response) {
    return getError(CAUSED_BY_BACK, message.response, getLineError(error));
  } else {
    return getError(
      seconds >= TIME_LIMIT
        ? CAUSED_BY_TIMEOUT
        : error.message === ERROR_CORS
        ? CAUSED_BY_CORS
        : CAUSED_BY_FRONT,
      error.message || error + "",
      getLineError(error),
      !error.message ? true : false
    );
  }
};

const sendLog = async (request, customSuccess, customError, step = {}) => {
  try {
    const { name = "SOAT", path, data, operation = "POST" } = request;
    if (path.includes(URL_AUDITORY)) {
      return;
    }

    const url = await getUrlConsume(name, path);
    const urlC = await getUrlClient();

    const { dispatch, state } = outAuditory;

    const log = {
      urlCliente: urlC,
      urlServicio: url,
      request: data || "",
      paso: state.step.paso,
      pasoDescripcion: state.step.pasoDescripcion,
      ...step,
    };
    if (!isEmpty(customSuccess)) {
      if (customSuccess?.config) {
        delete customSuccess.config;
      }
      log.respuestaExito =
        operation === "GET"
          ? customSuccess?.data || customSuccess
          : customSuccess;
      setSuccessLog(dispatch, log);
    }
    if (!isEmpty(customError)) {
      console.log("customError.error?.isCrash", customError.error?.isCrash);
      if (customError.error?.isCrash) {
        return logsAuditory(dispatch, state.auditoria, {
          paso: log.paso,
          pasoDescripcion: log.pasoDescripcion,
          urlServicio: "",
          urlCliente: urlC,
          respuestaError: JSON.stringify(customError),
          request: JSON.stringify(log.request),
        });
      }
      log.respuestaError = customError;
      setErrorLog(dispatch, log);
    }
  } catch (e) {}
};

export const withAuditoryAmplify = (typeApi, ApiConsume) => async (
  req1,
  req2,
  req3,
  req4
) => {
  let customSuccess = {};
  let customError = {};
  const { state, selector } = outAuditory;
  let request = {};

  switch (typeApi) {
    case "post":
      request = {
        name: req1,
        path: req2,
        data: {},
      };
      break;

    case "postWitchTrace":
      request = {
        name: req3,
        path: req1,
        data: helpers.getBody(req2, helpers.getLeadsTrace(req4)),
      };
      break;
    case "postWitchTraceSoat":
      request = {
        name: req3,
        path: req1,
        data: helpers.getBodySoat(req2, helpers.getLeadsTrace(req4)),
      };
      break;
    case "AmplifyApi":
      request = Object.assign(req1);
      break;
    default:
      request = Object.assign(req1);
      break;
  }

  const dateIni = new Date();
  const paso = {
    paso: state.step.paso,
    pasoDescripcion: state.step.pasoDescripcion,
  };

  try {
    customSuccess = await ApiConsume(req1, req2, req3, req4);
    return customSuccess;
  } catch (error) {
    const dateEnd = new Date();
    const errData = error.response?.data;
    if (errData) {
      customError =
        typeof errData === "object"
          ? errData
          : getError(CAUSED_BY_BACK, errData);
    } else {
      customError = readError(error, dateIni, dateEnd);
    }
    customError.selector = selector;
    throw error;
  } finally {
    setTimeout(() => sendLog(request, customSuccess, customError, paso))
  }
};

export const withAuditoryDigitalData = async ({
  code,
  error,
  endpoint = '',
  urlPageError = '',
  request,
}) => {
  try {
    let customError = {};
    const { selector, dispatch } = outAuditory;

    if (error?.stack) {
      customError = getError(code, error.stack + "", getLineError(error));
    } else if (typeof error === "object") {
      customError = getError(code, JSON.stringify(error), getLineError(error));
    } else {
      customError = getError(code, error + "", getLineError(error));
    }
    customError.urlRedirectError = urlPageError;
    customError.selector = selector;

    const urlC = await getUrlClient();

    setErrorLog(dispatch, {
      urlServicio: endpoint,
      urlCliente: urlC,
      respuestaError: customError,
      request: request,
    });
  } catch (error) {}
};

export const withAuditoryCrashlytics = async ({
  code,
  message,
  stack,
  error,
}) => {
  try {
    const { selector, dispatch, state } = outAuditory;
    const customError = getError(code, message, getLineError(error));
    customError.selector = selector;
    customError.stack = stack;
    const urlC = await getUrlClient();

    logsAuditory(dispatch, state.auditoria, {
      paso: state.step.paso,
      pasoDescripcion: state.step.pasoDescripcion,
      urlServicio: "",
      urlCliente: urlC,
      respuestaError: JSON.stringify(customError),
      request: "",
    });
  } catch (error) {}
};

export const withSuccessPayment = async (auditory) => {
  try {
    const { dispatch, state } = outAuditory;
    const urlC = await getUrlClient();
    logsAuditory(
      dispatch,
      {
        ...state.auditoria,
        ...auditory,
      },
      {
        paso: state.step.paso,
        pasoDescripcion: state.step.pasoDescripcion,
        urlCliente: urlC,
        request: "",
      }
    );
  } catch (error) {}
};
